/**
 * CNS (Cartão Nacional de Saúde) structural constants, shared by `isValidCns` and `formatCns`.
 *
 * @see Official: https://rni-docs.anvisa.gov.br/docs/regras_gerais/validacoes/validacaoCNS/
 * ANVISA's two validation routines, the ones implemented here. The page sits behind a bot filter
 * and answers HTTP 403 to every non-browser client, so it has to be opened in a browser.
 * @see Based on: https://integracao.esusab.ufsc.br/ledi/documentacao/regras/algoritmo_CNS.html
 * e-SUS APS documentation of the same DATASUS algorithm, reachable without a browser. It applies
 * the provisional routine to numbers starting with 5, 7, 8 or 9; this implementation follows the
 * ANVISA page, which restricts it to 7, 8 and 9, so a 5 prefixed number is rejected even when its
 * weighted sum checks out.
 */

/**
 * Shape a CNS number has to be written in: the 15 digits, optionally split into the printed
 * groups of 3, 4, 4 and 4 by whitespace or the usual mask characters. A run of separators is
 * tolerated between two groups, not just a single one, which is what the CPF, CNPJ, CAEPF and
 * certidão regexes of this library do.
 */
export const CNS_FORMAT_REGEX = /^\d{3}[\s.\-/]*\d{4}[\s.\-/]*\d{4}[\s.\-/]*\d{4}$/;

/** Digits of the PIS/PASEP/NIS derived base embedded in a definitive CNS (starts with 1 or 2). */
export const CNS_DEFINITIVE_BASE_LENGTH = 11;

/** Suffix between the base and the check digit of a definitive CNS whose raw check digit is not 10. */
export const CNS_DEFINITIVE_SUFFIX = "000";

/** Suffix used when the raw check digit is 10: the weighted sum is raised by 2 and the digit recomputed. */
export const CNS_DEFINITIVE_ADJUSTED_SUFFIX = "001";
